import React from "react";

import PRSwitch from "~components/Generic/PRSwitch";

import CreateResource from "./CreateResource";
export default function Resources() {
  const routes = [{ path: "/organization/reservations", component: CreateResource }];
  return <PRSwitch routes={routes} />;
}
